var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiwMobSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "hiw-mob-svg",
    width: 384,
    height: 1095,
    viewBox: "0 0 384 1095",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hiw-mob-svg 2",
    clipPath: "url(#clip0_3225_13089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hiw-mob-svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hiw-dotpaths"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hiw-dotpath1",
    d: "M248.5 67C248.5 67 316 66.5 325 66.5C334 66.5 337 70.5 337 70.5C337 70.5 339.5 72 340.5 76.5C341.5 81 340.5 277 340.5 277",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hiw-dotpath2",
    d: "M120 315.002C120 315.002 46.4998 315.001 40.4998 315.001C34.4998 315.001 30.92 317.007 29 320.501C27.08 323.995 27.4998 327.502 27.4998 327.502V476.502",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hiw-dotpath3",
    d: "M273.5 538H326.5C326.5 538 332 537.5 336 540.5C340 543.5 340.5 548 340.5 548V709",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hiw-dotpath4",
    d: "M120 758.5H38.5C38.5 758.5 32.5 759.5 30 763.5C27.5 767.5 27.5 772 27.5 772V902",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    filter: "url(#filter0_d_3225_13089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PRODUCER"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2372",
    d: "M132.897 199.399C135.886 197.674 138.89 197.743 140.887 198.897C142.899 200.058 143.02 201.792 140.031 203.518L138.589 204.35L142.269 206.474L139.821 207.887L129.008 201.645L132.897 199.399ZM138.004 202.347C139.265 201.619 139.625 201.047 138.394 200.336C137.208 199.651 136.231 199.868 134.97 200.596L133.528 201.428L136.562 203.18L138.004 202.347Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2373",
    d: "M159.197 196.702L156.389 198.323L149.645 197.448L148.067 198.358L152.199 200.742L149.751 202.155L138.938 195.913L142.932 193.607C145.801 191.951 148.878 191.873 150.83 193C152.091 193.728 152.377 194.777 151.761 195.826L159.197 196.702ZM143.427 195.679L146.19 197.274L147.798 196.346C149.135 195.575 149.495 195.107 148.339 194.439C147.288 193.832 146.372 193.98 144.975 194.786L143.427 195.679Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2374",
    d: "M154.187 186.883C157.371 185.045 161.907 184.871 165.391 186.883C168.89 188.903 168.575 191.512 165.391 193.35C162.222 195.18 157.687 195.353 154.202 193.342C150.718 191.33 151.019 188.712 154.187 186.883ZM163.318 192.154C165.436 190.932 165.271 189.726 162.868 188.339C160.48 186.961 158.377 186.857 156.26 188.079C154.157 189.293 154.338 190.507 156.726 191.885C159.128 193.272 161.216 193.368 163.318 192.154Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2375",
    d: "M165.543 180.553C169.162 178.463 173.292 178.403 176.626 180.327C179.96 182.252 179.885 184.758 176.356 186.795L172.481 189.032L161.668 182.79L165.543 180.553ZM174.283 185.599C176.536 184.298 176.506 183.136 174.133 181.767C171.76 180.397 169.958 180.397 167.615 181.749L166.188 182.573L172.856 186.422L174.283 185.599Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2376",
    d: "M179.795 172.325L182.243 170.912L188.716 174.649C191.179 176.071 191.869 178.065 188.565 179.972C185.277 181.871 181.822 181.472 179.359 180.05L172.887 176.314L175.335 174.9L181.973 178.733C183.625 179.686 184.751 179.782 186.493 178.776C188.25 177.761 188.085 177.111 186.433 176.158L179.795 172.325Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2377",
    d: "M198.144 172.051C199.976 170.993 199.691 170.256 198.76 169.476L201.223 168.054C202.83 169.415 203.4 171.409 200.216 173.247C197.033 175.085 192.497 174.981 189.238 173.1C185.904 171.175 185.859 168.6 189.013 166.779C192.212 164.933 195.306 165.314 197.738 166.129L195.291 167.542C193.999 167.109 192.888 166.935 191.085 167.976C189.118 169.112 189.313 170.23 191.761 171.643C194.179 173.039 196.267 173.134 198.144 172.051Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2378",
    d: "M206.97 166.729L212.331 163.634L214.403 164.83L206.594 169.338L195.781 163.096L203.41 158.692L205.483 159.888L200.302 162.879L202.374 164.076L207.39 161.18L209.402 162.342L204.386 165.238L206.97 166.729Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2379",
    d: "M225.529 158.407L222.721 160.028L215.978 159.153L214.401 160.063L218.531 162.447L216.083 163.86L205.27 157.618L209.265 155.312C212.133 153.656 215.212 153.578 217.164 154.705C218.426 155.433 218.711 156.482 218.095 157.531L225.529 158.407ZM209.76 157.384L212.524 158.979L214.131 158.052C215.467 157.28 215.828 156.812 214.671 156.144C213.62 155.537 212.704 155.685 211.307 156.491L209.76 157.384Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    filter: "url(#filter1_d_3225_13089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LOGISTICS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1360",
    d: "M194.04 405.766L199.409 408.865L196.943 410.289L188.723 405.544L201.316 398.274L204.166 399.92L194.04 405.766Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1361",
    d: "M216.852 406.98C220.56 409.12 220.909 412.17 216.852 414.512C212.777 416.865 207.512 416.653 203.805 414.512C200.114 412.382 199.764 409.332 203.822 406.99C207.88 404.647 213.162 404.849 216.852 406.98ZM206.218 413.119C208.684 414.542 211.115 414.431 213.914 412.816C216.694 411.21 216.904 409.797 214.438 408.373C211.99 406.96 209.541 407.081 206.76 408.686C203.962 410.302 203.77 411.705 206.218 413.119Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1362",
    d: "M225.563 419.038L231.299 422.35L224.566 426.238L222.309 424.935L224.023 423.946C222.799 424.208 220.263 424.016 218.287 422.875C214.194 420.513 214.544 417.544 218.322 415.363C222.222 413.112 227.626 413.203 231.352 415.353C234.867 417.383 234.57 419.331 233.153 420.876L230.302 419.23C230.914 418.513 230.722 417.776 228.938 416.746C226.664 415.434 224.111 415.373 221.225 417.039C218.724 418.483 217.972 419.907 220.735 421.502C222.414 422.471 224.566 423.289 226.979 422.28L223.464 420.25L225.563 419.038Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1363",
    d: "M226.656 427.445L239.249 420.175L242.1 421.821L229.507 429.091L226.656 427.445Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1364",
    d: "M243.687 426.714C242.97 427.128 243.214 427.593 244.963 429.289C247.237 431.49 248.077 432.943 245.698 434.316C243.005 435.871 239.524 435.135 236.551 433.419C233.333 431.561 233.263 429.843 235.082 428.087L237.95 429.743C237.058 430.48 237.163 431.106 238.825 432.066C240.504 433.035 241.605 433.328 242.777 432.651C243.599 432.177 243.442 431.621 241.693 429.966C239.279 427.663 238.737 426.26 240.783 425.079C243.389 423.574 246.905 424.332 249.476 425.816C252.624 427.633 252.834 429.349 251.137 431.035L248.304 429.4C249.039 428.613 248.811 428.077 247.167 427.128C245.75 426.31 244.719 426.119 243.687 426.714Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1365",
    d: "M255.799 429.729L266.626 435.979L264.16 437.402L260.172 435.1L250.045 440.946L247.195 439.301L257.321 433.455L253.333 431.152L255.799 429.729Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1366",
    d: "M255.676 444.197L268.269 436.928L271.119 438.574L258.527 445.843L255.676 444.197Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1367",
    d: "M268.91 449.314C271.044 450.546 272.53 450.354 274.104 449.728L276.973 451.384C274.227 452.464 270.204 452.848 266.496 450.707C262.789 448.567 262.998 445.517 266.794 443.326C270.676 441.085 275.871 441.055 279.544 443.175C283.269 445.326 282.5 447.406 280.856 449.041L278.005 447.395C278.879 446.527 279.229 445.78 277.13 444.568C274.839 443.246 272.583 443.377 269.732 445.023C266.916 446.648 266.724 448.052 268.91 449.314Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1368",
    d: "M286.113 451.206C285.396 451.62 285.641 452.084 287.39 453.781C289.663 455.982 290.503 457.436 288.124 458.809C285.431 460.364 281.95 459.627 278.977 457.91C275.759 456.053 275.689 454.336 277.508 452.579L280.376 454.235C279.484 454.972 279.589 455.598 281.251 456.557C282.93 457.527 284.032 457.819 285.203 457.143C286.025 456.668 285.868 456.113 284.119 454.457C281.706 452.155 281.163 450.752 283.21 449.57C285.816 448.066 289.331 448.823 291.902 450.307C295.05 452.125 295.26 453.841 293.564 455.528L290.73 453.892C291.465 453.104 291.237 452.569 289.593 451.62C288.177 450.802 287.145 450.61 286.113 451.206Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    filter: "url(#filter2_d_3225_13089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WHOLESALER"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3617",
    d: "M66.284 587.023L69.0465 588.786L65.1917 600.844L61.966 598.784L60.2986 587.336L57.6651 596.039L54.4395 593.979L51.8594 577.812L54.6716 579.609L56.3789 591.688L59.0717 582.419L61.9169 584.234L63.6077 596.305L66.284 587.023Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3618",
    d: "M78.0326 594.523L80.7287 596.245L80.0996 610.361L77.4036 608.64L77.6747 602.562L72.8109 599.457L72.54 605.535L69.8438 603.813L70.4727 589.697L73.1692 591.418L72.9314 596.751L77.7946 599.856L78.0326 594.523Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3619",
    d: "M88.7452 601.101C92.2522 603.34 94.7922 607.805 94.5892 612.353C94.3852 616.921 91.6002 617.966 88.0932 615.727C84.6032 613.499 82.0632 609.034 82.2652 604.485C82.4682 599.937 85.2552 598.872 88.7452 601.101ZM88.2142 613.021C90.5462 614.511 91.6702 613.716 91.8102 610.579C91.9492 607.462 90.9572 605.296 88.6242 603.806C86.3082 602.328 85.1832 603.142 85.0442 606.259C84.9052 609.396 85.8982 611.543 88.2142 613.021Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3620",
    d: "M98.9479 619.552L104.027 622.794L103.904 625.557L96.1289 620.594L96.7579 606.479L99.4539 608.198L98.9479 619.552Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3621",
    d: "M108.282 625.57L114.187 629.341L114.067 632.047L105.465 626.555L106.094 612.438L114.497 617.803L114.377 620.509L108.67 616.865L108.549 619.571L114.074 623.099L113.957 625.727L108.432 622.198L108.282 625.57Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3622",
    d: "M118.821 624.538C118.785 625.342 119.267 625.973 121.454 628.055C124.294 630.755 125.84 632.71 125.721 635.376C125.587 638.396 123.282 638.195 120.47 636.399C117.426 634.456 116.06 631.91 115.602 628.815L118.315 630.547C118.443 631.879 118.981 632.787 120.552 633.79C122.14 634.804 122.916 634.956 122.975 633.643C123.016 632.721 122.506 631.932 120.351 629.911C117.363 627.096 116.004 625.14 116.106 622.846C116.236 619.924 118.574 620.147 121.006 621.699C123.984 623.6 125.42 626.11 125.883 629.068L123.204 627.357C122.958 625.99 122.43 625.25 120.875 624.257C119.535 623.401 118.872 623.382 118.821 624.538Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3623",
    d: "M135.118 630.848L139.082 648.019L136.22 646.191L135.475 642.691L130.313 639.396L129.306 641.777L126.477 639.971L131.71 628.673L135.118 630.848ZM131.053 637.307L134.94 639.789L133.273 632.534L131.053 637.307Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3624",
    d: "M143.289 647.861L148.367 651.103L148.244 653.868L140.469 648.904L141.098 634.788L143.795 636.509L143.289 647.861Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3625",
    d: "M152.626 653.882L158.532 657.652L158.411 660.358L149.809 654.866L150.438 640.75L158.842 646.115L158.721 648.82L153.014 645.177L152.894 647.883L158.418 651.41L158.301 654.037L152.776 650.51L152.626 653.882Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3626",
    d: "M170.663 668.183L167.57 666.208L164.931 658.979L163.195 657.87L162.954 663.262L160.258 661.54L160.887 647.424L165.287 650.233C168.447 652.25 170.131 655.302 170.017 657.85C169.944 659.497 169.039 660.331 167.664 660.26L170.663 668.183ZM163.465 651.812L163.304 655.419L165.074 656.549C166.546 657.489 167.204 657.607 167.272 656.097C167.333 654.725 166.707 653.882 165.168 652.899L163.465 651.812Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    filter: "url(#filter3_d_3225_13089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RETAILER"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4090",
    d: "M175.778 855.74L172.411 853.75L169.34 846.141L167.449 845.021L167.388 850.781L164.453 849.042L164.614 833.98L169.403 836.811C172.842 838.851 174.747 842.04 174.718 844.76C174.699 846.51 173.765 847.441 172.298 847.411L175.778 855.74ZM167.518 838.561L167.477 842.411L169.404 843.552C171.006 844.502 171.712 844.6 171.729 842.99C171.745 841.52 171.047 840.651 169.373 839.661L167.518 838.561Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4091",
    d: "M180.2 855.451L186.627 859.261L186.597 862.141L177.234 856.601L177.395 841.541L186.541 846.951L186.51 849.841L180.299 846.171L180.268 849.051L186.282 852.611L186.252 855.411L180.238 851.861L180.2 855.451Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4092",
    d: "M187.946 847.78L199.091 854.38L199.059 857.33L194.954 854.9L194.825 867.01L191.89 865.28L192.019 853.16L187.914 850.73L187.946 847.78Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4093",
    d: "M206.959 858.912L211.802 877.062L208.687 875.222L207.766 871.512L202.149 868.192L201.161 870.762L198.082 868.942L203.25 856.722L206.959 858.912ZM202.861 865.942L207.093 868.442L205.054 860.772L202.861 865.942Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4094",
    d: "M213.316 877.962L213.477 862.892L216.412 864.632L216.251 879.692L213.316 877.962Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4095",
    d: "M221.732 879.97L227.26 883.24L227.228 886.19L218.766 881.18L218.926 866.12L221.861 867.85L221.732 879.97Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4096",
    d: "M231.895 886.042L238.323 889.852L238.292 892.732L228.93 887.192L229.09 872.132L238.237 877.542L238.206 880.432L231.994 876.762L231.964 879.642L237.977 883.202L237.947 886.002L231.934 882.452L231.895 886.042Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4097",
    d: "M251.63 900.63L248.263 898.64L245.192 891.03L243.301 889.91L243.24 895.66L240.305 893.93L240.466 878.86L245.255 881.7C248.694 883.73 250.598 886.92 250.569 889.64C250.551 891.4 249.617 892.32 248.15 892.3L251.63 900.63ZM243.37 883.45L243.329 887.3L245.255 888.44C246.858 889.38 247.563 889.49 247.581 887.87C247.596 886.41 246.899 885.53 245.225 884.54L243.37 883.45Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    filter: "url(#filter4_d_3225_13089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CONSUMER"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4098",
    d: "M118.687 1074.8C120.963 1073.34 121.525 1071.8 121.708 1069.95L124.768 1067.99C124.437 1071.21 122.784 1075.32 118.828 1077.86C114.873 1080.39 112.006 1078.65 111.783 1073.85C111.555 1068.93 114.143 1063.85 118.061 1061.34C122.036 1058.79 123.676 1060.59 124.442 1063.02L121.4 1064.97C120.994 1063.68 120.442 1062.96 118.203 1064.4C115.759 1065.96 114.75 1068.23 114.917 1071.84C115.083 1075.4 116.354 1076.3 118.687 1074.8Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4099",
    d: "M132.646 1051.99C136.602 1049.46 139.751 1050.65 139.989 1055.79C140.229 1060.95 137.369 1065.97 133.413 1068.51C129.476 1071.03 126.327 1069.84 126.088 1064.7C125.85 1059.56 128.709 1054.52 132.646 1051.99ZM133.271 1065.45C135.902 1063.77 137.019 1061.34 136.854 1057.8C136.691 1054.28 135.419 1053.36 132.788 1055.05C130.176 1056.72 129.06 1059.17 129.223 1062.69C129.388 1066.23 130.659 1067.13 133.271 1065.45Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4100",
    d: "M153.634 1038.83L154.374 1054.78L151.071 1056.89L144.911 1049.19L145.436 1060.5L142.451 1062.42L141.711 1046.48L145.405 1044.11L151.184 1051.46L150.685 1040.72L153.634 1038.83Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4101",
    d: "M159.213 1039.75C159.255 1040.66 159.832 1040.65 162.367 1039.8C165.659 1038.69 167.499 1038.61 167.639 1041.62C167.797 1045.03 165.325 1048.05 162.153 1050.08C158.719 1052.28 157.011 1051.49 156.215 1048.83L159.275 1046.87C159.544 1048.11 160.207 1048.32 161.98 1047.19C163.771 1046.04 164.612 1045.11 164.543 1043.63C164.494 1042.59 163.874 1042.46 161.378 1043.33C157.917 1044.52 156.276 1044.34 156.155 1041.75C156.002 1038.45 158.512 1035.41 161.255 1033.65C164.614 1031.5 166.393 1032.16 167.181 1034.66L164.159 1036.6C163.761 1035.49 163.125 1035.44 161.371 1036.56C159.86 1037.53 159.153 1038.44 159.213 1039.75Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4102",
    d: "M177.696 1023.41L180.738 1021.46L181.181 1031C181.349 1034.63 179.775 1038.79 175.67 1041.42C171.583 1044.04 169.725 1042.08 169.556 1038.45L169.113 1028.91L172.155 1026.96L172.609 1036.75C172.722 1039.18 173.363 1039.75 175.528 1038.36C177.711 1036.96 178.264 1035.63 178.151 1033.19L177.696 1023.41Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4103",
    d: "M194.263 1012.79L198.573 1010.02L199.313 1025.97L196.328 1027.88L195.801 1016.54L193.162 1029.22L190.046 1031.22L186.453 1022.54L186.98 1033.87L183.994 1035.79L183.254 1019.85L187.62 1017.05L191.469 1026.27L194.263 1012.79Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4104",
    d: "M204.824 1019.29L211.485 1015.02L211.627 1018.07L201.924 1024.29L201.184 1008.35L210.662 1002.27L210.804 1005.33L204.367 1009.46L204.509 1012.51L210.741 1008.52L210.879 1011.48L204.647 1015.48L204.824 1019.29Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4105",
    d: "M225.449 1009.21L221.96 1011.45L218.431 1007.44L216.472 1008.7L216.755 1014.78L213.713 1016.73L212.973 1000.79L217.936 997.61C221.5 995.33 223.597 996.22 223.731 999.09C223.817 1000.95 222.938 1003.11 221.467 1004.97L225.449 1009.21ZM216.154 1001.85L216.343 1005.93L218.34 1004.65C220 1003.58 220.713 1002.78 220.634 1001.08C220.562 999.53 219.811 999.51 218.076 1000.62L216.154 1001.85Z",
    fill: "#222222"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 482235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hiw-dot4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_4",
    d: "M-6.35156 11.3779L6.02785 0.0012453L-7.00169 -10.6247L-6.35156 11.3779Z",
    fill: "url(#paint0_radial_3225_13089)",
    stroke: "#222222",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "hiw-dot3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_2",
    d: "M-7.00168 -10.6245L6.02682 0.00139414L-6.35156 11.3779L-7.00168 -10.6245Z",
    fill: "url(#paint1_radial_3225_13089)",
    stroke: "#222222",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "hiw-dot2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_3",
    d: "M-6.35156 11.3779L6.02685 0.00127504L-7.00169 -10.6247L-6.35156 11.3779Z",
    fill: "url(#paint2_radial_3225_13089)",
    stroke: "#222222",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "hiw-dot1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M-7.00168 -10.6245L6.02684 0.00139369L-6.35156 11.3779L-7.00168 -10.6245Z",
    fill: "url(#paint3_radial_3225_13089)",
    stroke: "#222222",
    strokeWidth: 3
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3225_13089",
    x: 122.008,
    y: 150.949,
    width: 114.52,
    height: 71.9385,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3225_13089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3225_13089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3225_13089",
    x: 181.723,
    y: 395.274,
    width: 123.895,
    height: 79.3867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3225_13089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3225_13089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3225_13089",
    x: 44.8594,
    y: 574.812,
    width: 136.805,
    height: 108.37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3225_13089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3225_13089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3225_13089",
    x: 157.453,
    y: 830.98,
    width: 105.176,
    height: 84.6504,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3225_13089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3225_13089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3225_13089",
    x: 104.77,
    y: 993.318,
    width: 131.68,
    height: 100.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3225_13089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3225_13089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3225_13089",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.82068 -11.3673) rotate(-68.9707) scale(65.0935 27.4687)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3225_13089",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.49448 11.5392) rotate(65.5856) scale(65.0935 27.4688)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3225_13089",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.81768 -11.3672) rotate(-68.9706) scale(65.0935 27.4688)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3225_13089",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.49449 11.5392) rotate(65.5855) scale(65.0936 27.4688)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3225_13089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 1095,
    fill: "white"
  })), /*#__PURE__*/React.createElement("style", null, "\n* {\n        margin: 0;\n        padding: 0;\n        -webkit-box-sizing: border-box;\n                box-sizing: border-box;\n      }\n      \n      /* trackDotLayer CSS */\n      @-webkit-keyframes hiwTrackDotAnim {\n        0% {\n            offset-distance: 0%;\n            opacity: 0;\n        }\n        1%{\n            offset-distance: 0%;\n            opacity: 1;\n        }\n        24%{\n            opacity: 1;\n            offset-distance: 100%;\n        }\n        25%{\n            opacity: 0;\n            offset-distance: 100%;\n        }\n        100%{\n            opacity: 0;\n            offset-distance: 100%;\n        }\n      }\n      @keyframes hiwTrackDotAnim {\n        0% {\n            offset-distance: 0%;\n            opacity: 0;\n        }\n        1%{\n            offset-distance: 0%;\n            opacity: 1;\n        }\n        24%{\n            opacity: 1;\n            offset-distance: 100%;\n        }\n        25%{\n            opacity: 0;\n            offset-distance: 100%;\n        }\n        100%{\n            opacity: 0;\n            offset-distance: 100%;\n        }\n      }\n      \n\n      .hiw-mob-svg.active #hiw-dot1, \n.hiw-mob-svg.active #hiw-dot2, \n.hiw-mob-svg.active #hiw-dot3, \n.hiw-mob-svg.active #hiw-dot4{\n    opacity: 0;\n    -webkit-animation: hiwTrackDotAnim 12s linear forwards infinite;\n            animation: hiwTrackDotAnim 12s linear forwards infinite;\n    -webkit-animation-delay: 0s;\n            animation-delay: 0s;\n}\n.hiw-mob-svg.active #hiw-dot1{\n    offset-path: path('M248.5 67C248.5 67 316 66.5 325 66.5C334 66.5 337 70.5 337 70.5C337 70.5 339.5 72 340.5 76.5C341.5 81 340.5 277 340.5 277');\n}\n.hiw-mob-svg.active #hiw-dot2{\n    offset-path: path('M120 315.001C120 315.001 46.4998 315 40.4998 315C34.4998 315 30.92 317.006 29 320.5C27.08 323.994 27.4998 327.501 27.4998 327.501V476.501');\n    animation-delay: 3s;\n}\n.hiw-mob-svg.active #hiw-dot3{\n    offset-path: path('M273.5 538H326.5C326.5 538 332 537.5 336 540.5C340 543.5 340.5 548 340.5 548V709');\n    animation-delay: 6s;\n}\n.hiw-mob-svg.active #hiw-dot4{\n    offset-path: path('M120 758.5H38.5C38.5 758.5 32.5 759.5 30 763.5C27.5 767.5 27.5 772 27.5 772V902');\n    animation-delay: 9s;\n}\n#hiw-dotpath1, #hiw-dotpath2, #hiw-dotpath3, #hiw-dotpath4{stroke:transparent}\n"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiwMobSvg);
export default __webpack_public_path__ + "static/media/hiw-mob-svg.0c899ccd1baa05538ffb12aad49784df.svg";
export { ForwardRef as ReactComponent };